import { esInstagramPalettes } from "../../../../Posts/05-tematicas/05-instagram/instagramPalettes.js";
import { localizeTematicPalettes } from "../../../../src/helpers/localizeTematicPalettes.js";
import * as React from 'react';
export default {
  esInstagramPalettes,
  localizeTematicPalettes,
  React
};